// @ts-nocheck
import React, { useEffect, useRef, useState, MouseEvent, DragEvent } from "react";
import BraintreeDropIn from './BrainTreeDropIn';

const styles = `
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;500;700;800&family=Playfair+Display:ital,wght@1,600&display=swap');

:root {
    --bg-body: #F9FAFB;
    --bg-card: #FFFFFF;
    --bg-slot: #F0F2F5;
    --primary: #FF6B6B;
    --secondary: #6C5CE7;
    --text-dark: #2D3436;
    --text-light: #636E72;
    --border-color: #E2E8F0;
    --shadow-soft: 0 10px 40px rgba(0, 0, 0, 0.05);
    --shadow-pop: 0 15px 35px rgba(0, 0, 0, 0.15);
    --radius-lg: 24px;
    --radius-sm: 12px;
    --video-aspect: 9/16;
    --preview-width: 350px;
}

* {
    box-sizing: border-box;
}

body {
    margin: 0;
    padding: 0;
    background-color: var(--bg-body);
    color: var(--text-dark);
    font-family: 'Outfit', sans-serif;
    overflow-x: hidden;
}

/* --- Drag Overlay --- */
#drag-overlay {
    position: fixed;
    inset: 15px;
    border: 4px dashed var(--secondary);
    border-radius: var(--radius-lg);
    background: rgba(255, 255, 255, 0.95);
    z-index: 9999;
    display: none;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    pointer-events: none;
}

#drag-overlay h2 {
    color: var(--secondary);
    font-size: 2rem;
    margin: 0;
}

#drag-overlay p {
    color: var(--text-light);
    margin-top: 10px;
}

body.dragging-active #drag-overlay {
    display: flex;
    animation: pulse-border 1.5s infinite;
}

@keyframes pulse-border {
    0% { border-color: var(--primary); }
    50% { border-color: var(--secondary); }
    100% { border-color: var(--primary); }
}

/* Intro Modal Card */
.intro-card {
    background: white;
    padding: 30px;
    border-radius: 30px;
    max-width: 780px;
    width: 90%;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
    animation: modalPop 0.4s cubic-bezier(.22, 1.11, .56, 1.14);
    text-align: center;
}

.intro-title {
    color: var(--primary);
    font-size: 2rem;
    margin-bottom: 10px;
    font-style: italic;
}

.intro-desc {
    font-size: 1rem;
    color: var(--text-light);
    margin-top: 0;
    margin-bottom: 25px;
}

/* BEFORE / AFTER layout */
.before-after-row {
    display: flex;
    gap: 25px;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 25px;
}
    .left-scroll-wrapper {
    flex: 1;
    overflow-y: auto;
    max-height: calc(100vh - 120px);
}

.before-col,
.after-col {
    flex: 1;
    text-align: center;
}

.before-label,
.after-label {
    font-size: 1.2rem;
    margin-bottom: 10px;
    font-style: italic;
}

.before-collage {
    position: relative;
    width: 100%;
    padding-top: 60%;
}

.before-collage img {
    position: absolute;
    width: 60%;
    height: auto;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    opacity: 0.9;
    transition: transform .3s ease;
}

.before-collage img:nth-child(1) {
    top: 0;
    left: 10%;
    transform: rotate(-4deg);
}

.before-collage img:nth-child(2) {
    top: 15%;
    left: 25%;
    transform: rotate(2deg);
}

.before-collage img:nth-child(3) {
    top: 30%;
    left: 5%;
    transform: rotate(-1deg);
}

.intro-btn {
    padding: 14px 40px;
    background: linear-gradient(45deg, var(--primary), #FF9F43);
    border: none;
    border-radius: 50px;
    color: white;
    font-size: 1.1rem;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 10px 20px rgba(255, 107, 107, 0.4);
}

.intro-btn:hover {
    transform: translateY(-2px);
}

.filter-badge {
    position: absolute;
    bottom: 5px;
    right: 5px;
    background: rgba(108, 92, 231, 0.85);
    color: white;
    font-size: 0.7rem;
    padding: 3px 6px;
    border-radius: 8px;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.15s ease;
}

.asset-slot.filled:hover .filter-badge {
    opacity: 1;
}

/* --- Navbar --- */
.navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 30px;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    position: sticky;
    top: 0;
    z-index: 100;
    border-bottom: 1px solid var(--border-color);
}

.replace-preview-btn:hover,
.remove-preview-btn:hover {
    opacity: 0.8;
    transform: translateY(-1px);
}

.video-container video {
    display: block;
}

.brand {
    font-family: 'Playfair Display', serif;
    font-size: 1.5rem;
    font-style: italic;
}

.brand span {
    color: var(--primary);
}

/* --- Layout --- */
.studio-grid {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    max-width: 1600px;
    margin: 0 auto;
    padding: 20px;
    gap: 40px;
    position: relative;
}

.editor-panel {
    overflow-y: visible; /* change from auto to visible */
    max-height: none;
}

/* Custom scrollbars inside editor-panel */
.editor-panel::-webkit-scrollbar {
    width: 10px;
}
.editor-panel::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}
.editor-panel::-webkit-scrollbar-thumb {
    background: var(--primary);
    border-radius: 10px;
}
.editor-panel::-webkit-scrollbar-thumb:hover {
    background: #ff958f;
}

/* Firefox */
.editor-panel {
    scrollbar-width: thin;
    scrollbar-color: var(--primary) #f1f1f1;
}

.preview-panel {
    width: var(--preview-width);
    flex-shrink: 0;
    height: fit-content;
    position: sticky;
    top: 90px;
    transition: width 0.3s ease;
}

/* --- Package Selector --- */
.package-selector {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    padding-bottom: 5px;
    margin-bottom: 10px;
}

.pkg-card {
    flex: 1;
    min-width: 100px;
    background: var(--bg-card);
    padding: 15px;
    border-radius: var(--radius-sm);
    border: 2px solid transparent;
    cursor: pointer;
    transition: 0.2s;
    text-align: center;
    white-space: nowrap;
}

.pkg-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
}

.pkg-card.active {
    border-color: var(--primary);
    background: #FFF5F5;
    box-shadow: 0 12px 30px rgba(255, 107, 107, 0.2);
}

.pkg-price {
    color: var(--primary);
    font-weight: 800;
    font-size: 1.2rem;
    margin-bottom: 4px;
}

.timeline-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* --- Scene Card & Assets --- */
.scene-card {
    background: var(--bg-card);
    border-radius: var(--radius-lg);
    padding: 20px;
    box-shadow: var(--shadow-soft);
    transition: 0.2s;
    border: 1px solid gray;
}

.scene-card.drop-target-scene {
    border-color: var(--secondary);
    box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.25);
}

.scene-header {
    display: flex;
    justify-content: space-between;
    color: var(--text-light);
    margin-bottom: 15px;
    font-weight: 700;
    font-size: 1.05rem;
}

.scene-assets {
    display: flex;
    gap: 10px;
    min-height: 120px;
    transition: all 0.3s ease;
}

.asset-slot:not(.filled) {
    aspect-ratio: 1 / 1;   /* 🔥 forces a perfect square */
    width: 110px;           /* keeps them consistent across screens */
    max-width: 110px;
    min-width: 110px;
}

.asset-slot {
    flex: 1;
    background: var(--bg-slot);
    border-radius: 12px;
    border: 2px dashed #CBD5E0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.3s ease;
}

.asset-slot:hover {
    border-color: var(--primary);
    background: #fff;
}

.asset-slot.filled {
    border: none;
    background: black;
    flex: 1; /* allow equal sharing of row space */
    max-width: 120px; /* cap width so they never stretch too far */
    min-width: 90px;  /* keep reasonable size on large screens */
    height: 120px; /* make them square-ish and stable */
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}


.asset-slot.drop-target {
    border-style: solid;
    border-color: var(--secondary);
    box-shadow: 0 0 0 2px rgba(108, 92, 231, 0.25);
    background: #f4f2ff;
}

.asset-slot img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: filter 0.3s ease, transform 0.3s ease;
    pointer-events: none;
}

.asset-slot.filled img {
    pointer-events: auto;
}

.remove-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 20px;
    height: 20px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
    opacity: 0;
    transition: 0.2s;
    z-index: 10;
}

.remove-btn:hover {
    background: var(--primary);
    transform: scale(1.1);
}

.asset-slot.filled:hover .remove-btn {
    opacity: 1;
}

.add-hint {
    font-size: 2rem;
    color: #ccc;
    pointer-events: none;
}

.slot-label {
    position: absolute;
    bottom: 5px;
    font-size: 0.7rem;
    color: #888;
    pointer-events: none;
}

.scene-prompt {
    min-height: 80px;
    width: 100%;
    margin-top: 15px;
    padding: 12px;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    font-family: inherit;
    font-size: 0.9rem;
    resize: vertical;
}

/* --- Video Preview --- */
.video-container {
    width: 100%;
    aspect-ratio: var(--video-aspect);
    background: #000;
    border-radius: var(--radius-lg);
    position: relative;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
    transition: aspect-ratio 0.4s ease;
}

.ratio-toggles {
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 10;
    display: flex;
    gap: 5px;
}

.ratio-btn {
    background: rgba(0, 0, 0, 0.6);
    color: white;
    border: none;
    padding: 5px 10px;
    border-radius: 20px;
    cursor: pointer;
    font-size: 0.7rem;
}

.ratio-btn.active {
    background: var(--primary);
}

.video-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    background: linear-gradient(160deg, #2d3436, #000);
}

.generate-btn {
    width: 100%;
    padding: 18px;
    background: linear-gradient(45deg, var(--primary), #FF9F43);
    color: white;
    border: none;
    border-radius: var(--radius-sm);
    font-weight: 800;
    font-size: 1.1rem;
    cursor: pointer;
    margin-top: 20px;
    text-transform: uppercase;
    box-shadow: 0 10px 20px rgba(255, 107, 107, 0.4);
}

/* --- Transformation Header --- */
.transformation-header {
    margin-top: 20px;
}

.transformation-header h4 {
    margin: 20px 0 10px;
}

/* --- Context Menu --- */
#context-menu {
    position: absolute;
    width: 180px;
    background: white;
    border-radius: 12px;
    box-shadow: var(--shadow-pop);
    display: none;
    flex-direction: column;
    overflow: hidden;
    z-index: 999;
    border: 1px solid #eee;
}

.ctx-item {
    padding: 12px 15px;
    cursor: pointer;
    font-size: 0.9rem;
    display: flex;
    justify-content: space-between;
    color: var(--text-dark);
    transition: 0.1s;
    position: relative;
}

.ctx-item:hover {
    background: #f5f5f5;
    color: var(--secondary);
}

.ctx-divider {
    height: 1px;
    background: #eee;
    margin: 4px 0;
}

.ctx-submenu {
    display: none;
    position: absolute;
    left: 100%;
    top: 0;
    width: 150px;
    background: white;
    border-radius: 12px;
    box-shadow: var(--shadow-pop);
    border: 1px solid #eee;
}

/* on hover over the "Filters" row, show all the filter options */
.ctx-item:hover .ctx-submenu {
    display: flex;
    flex-direction: column;
}

/* --- Confirmation Modal --- */
.modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
    z-index: 10000;
    display: none;
    justify-content: center;
    align-items: center;
}

.modal-backdrop.show {
    display: flex;
}

.modal-card {
    background: white;
    padding: 30px;
    border-radius: 24px;
    text-align: center;
    width: 90%;
    max-width: 350px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
    animation: modalPop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.modal-title {
    font-family: 'Playfair Display', serif;
    font-size: 1.5rem;
    margin-bottom: 10px;
}

.modal-actions {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    justify-content: center;
}

.btn-modal {
    padding: 10px 20px;
    border-radius: 50px;
    border: none;
    cursor: pointer;
    font-weight: 600;
}

.btn-cancel {
    background: #eee;
    color: var(--text-dark);
}

.btn-confirm {
    background: var(--primary);
    color: white;
}

@keyframes modalPop {
    0% { opacity: 0; transform: scale(0.8); }
    100% { opacity: 1; transform: scale(1); }
}

/* --- Tiny equalizer bounce --- */
@keyframes bounce {
    0%, 100% { height: 5px; }
    50% { height: 100%; }
}

/* --- Responsiveness --- */
@media (max-width: 1000px) {
    .studio-grid {
        flex-direction: column-reverse;
        padding: 10px;
    }

    .preview-panel {
        width: 100%;
        position: relative;
        top: auto;
        z-index: 10;
        background: transparent;
        padding: 0;
        border: none;
        margin-bottom: 20px;
    }

    .video-container {
        max-width: 330px;
        margin: 0 auto;
        aspect-ratio: var(--video-aspect);
    }

    .navbar {
        padding: 10px 20px;
    }

    .ba-carousel,
    .transformation-header {
        display: none;
    }
}

/* Google Sign-In microanimations */
@keyframes popInScale {
    0% { opacity: 0; transform: scale(0.92); }
    100% { opacity: 1; transform: scale(1); }
}

/* Microinteraction for wiggle if moved left-right */
#google-signin-btn.wiggle {
    animation: btnWiggle 0.33s cubic-bezier(.63, 1.7, .43, 1.04);
}

@keyframes btnWiggle {
    0% { transform: scale(0.97) rotate(-2deg); }
    28% { transform: scale(1.05) rotate(2deg); }
    52% { transform: scale(0.997) rotate(-2deg); }
    73% { transform: scale(1.025) rotate(1deg); }
    100% { transform: scale(1) rotate(0deg); }
}

@media (max-width: 600px) {
    .responsive-radius {
        border-radius: var(--radius-sm) !important;
    }
}
`;

type AssetSlot = {
  id: string;
  imageSrc: string | null;
  filter: string;
};

type Scene = {
  index: number;
  prompt: string;
  slots: AssetSlot[];
};

type DragSource = {
  sceneIndex: number;
  slotId: string;
} | null;

type ContextTarget = {
  sceneIndex: number;
  slotId: string;
} | null;

const defaultPromptScene1 =
  "Emily and Clara pose in their matching Christmas dresses as their mother Anna snaps the photo. In spring, Anna watches proudly as Emily runs through the tall grass behind their farmhouse. By summer, she pulls both girls close for a simple, tender family portrait.";

const createEmptySlot = (sceneIndex: number, slotIdx: number): AssetSlot => ({
  id: `scene-${sceneIndex}-slot-${slotIdx}`,
  imageSrc: null,
  filter: "none",
});

const LifeReplayedStudio: React.FC = () => {
  const rootRef = useRef<HTMLDivElement | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [scenes, setScenes] = useState<Scene[]>(() => {
    const initialSlots: AssetSlot[] = [
      { id: "scene-1-slot-1", imageSrc: "image1.jpg", filter: "none" },
      { id: "scene-1-slot-2", imageSrc: "image2.jpg", filter: "none" },
      { id: "scene-1-slot-3", imageSrc: "image3.jpg", filter: "none" },
    ];
    return [
      {
        index: 1,
        prompt: defaultPromptScene1,
        slots: initialSlots,
      },
      // pre-create empty scenes up to 8
      ...Array.from({ length: 7 }, (_, i) => {
        const index = i + 2;
        return {
          index,
          prompt: "",
          slots: [createEmptySlot(index, 1)],
        };
      }),
    ];
  });

  const [currentSceneCount, setCurrentSceneCount] = useState<number>(8);
  const [price, setPrice] = useState<number>(59.9);

  const [videoAspect, setVideoAspect] = useState<"9/16" | "16/9">("9/16");
  const [previewWidth, setPreviewWidth] = useState<string>("350px");
  const [showIntroModal, setShowIntroModal] = useState<boolean>(false);
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const [userEmail, setUserEmail] = useState<string>("");
  const [emailConfirmed, setEmailConfirmed] = useState<boolean>(false);
  const [confirmedEmail, setConfirmedEmail] = useState<string>("");
  const [paymentProcessing, setPaymentProcessing] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showCheckoutModal, setShowCheckoutModal] = useState<boolean>(false);
  const [slotToDelete, setSlotToDelete] = useState<ContextTarget>(null);
  const [showGoogleModal, setShowGoogleModal] = useState<boolean>(false);

  const [dragSource, setDragSource] = useState<DragSource>(null);
  const [sceneDropHighlight, setSceneDropHighlight] = useState<number | null>(
    null
  );
  const [slotDropHighlight, setSlotDropHighlight] = useState<string | null>(
    null
  );

  const [isExternalDragActive, setIsExternalDragActive] =
    useState<boolean>(false);

  const [contextTarget, setContextTarget] = useState<ContextTarget>(null);
  const [ctxMenuVisible, setCtxMenuVisible] = useState<boolean>(false);
  const [ctxMenuPos, setCtxMenuPos] = useState<{ x: number; y: number }>({
    x: 0,
    y: 0,
  });
  const [originalFilter, setOriginalFilter] = useState<string>("none");
  const [tempFilter, setTempFilter] = useState<string | null>(null);

  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [fileTarget, setFileTarget] = useState<ContextTarget>(null);

  const [isPlayButtonVisible, setIsPlayButtonVisible] = useState<boolean>(
    false
  );


  // bad code we should really be uploading the images to aws and then using the url here
  // Convert blob URL to base64
const getBase64FromBlobUrl = async (blobUrl: string): Promise<string> => {
  const res = await fetch(blobUrl);
  const blob = await res.blob();

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.readAsDataURL(blob);
  });
};


  const fullOrder = React.useMemo(async () => {
    const sceneData = [];
  
    for (const scene of scenes.filter((s) => s.index <= currentSceneCount)) {
      const assetData = [];
  
      for (const slot of scene.slots) {
        let base64 = null;
  
        if (slot.imageSrc) {
          base64 = await getBase64FromBlobUrl(slot.imageSrc);
        }
  
        assetData.push({
          id: slot.id,
          filter: slot.filter,
          imageBase64: base64,
        });
      }
  
      sceneData.push({
        index: scene.index,
        prompt: scene.prompt,
        assets: assetData,
      });
    }
  
    return {
      scenes: sceneData,
      aspectRatio: videoAspect,
      totalScenes: currentSceneCount,
      price,
      email: userEmail,
    };
  }, [scenes, currentSceneCount, price, userEmail]);
  


  useEffect(() => {
    if (!showDeleteModal) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Enter" || e.key === "Return") {
        e.preventDefault();
        confirmDelete();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [showDeleteModal]);

  // intro modal: show once
  useEffect(() => {
    try {
      const alreadySeen = localStorage.getItem("lr_intro_seen");
      if (!alreadySeen) {
        setShowIntroModal(true);
      }
    } catch {
      // ignore
    }
  }, []);

  const closeIntroModal = () => {
    setShowIntroModal(false);
    try {
      localStorage.setItem("lr_intro_seen", "yes");
    } catch {
      // ignore
    }
  };


  const checkout = () => {
    alert("Checkout flow would go here.");
    hideCheckoutModal();
  };

  const showGoogleSignInModal = () => setShowGoogleModal(true);
  const hideGoogleSignInModal = () => setShowGoogleModal(false);
  const googleSignIn = () => {
    alert("Google Sign-In flow would go here.");
    hideGoogleSignInModal();
  };

  // update CSS vars on root for aspect/width
  useEffect(() => {
    if (!rootRef.current) return;
    const el = rootRef.current;
    el.style.setProperty("--video-aspect", videoAspect);
    el.style.setProperty("--preview-width", previewWidth);
  }, [videoAspect, previewWidth]);

  // global click to close context menu and reset preview filter
  useEffect(() => {
    const handleClick = () => {
      if (contextTarget && tempFilter !== null) {
        // revert preview filter to original
        setScenes((prev) =>
          prev.map((scene) => {
            if (scene.index !== contextTarget.sceneIndex) return scene;
            return {
              ...scene,
              slots: scene.slots.map((slot) => {
                if (slot.id !== contextTarget.slotId) return slot;
                return { ...slot, filter: originalFilter };
              }),
            };
          })
        );
      }
      setCtxMenuVisible(false);
      setContextTarget(null);
      setTempFilter(null);
    };
    window.addEventListener("click", handleClick);
    return () => window.removeEventListener("click", handleClick);
  }, [contextTarget, originalFilter, tempFilter, setScenes]);

  // external drag overlay
  useEffect(() => {
    let dragCounter = 0;
    const onDragEnter = (e: DragEvent | any) => {
      if (e.dataTransfer?.types?.includes("Files")) {
        dragCounter++;
        setIsExternalDragActive(true);
        document.body.classList.add("dragging-active");
      }
    };
    const onDragLeave = (e: DragEvent | any) => {
      if (e.dataTransfer?.types?.includes("Files")) {
        dragCounter--;
        if (dragCounter <= 0) {
          dragCounter = 0;
          setIsExternalDragActive(false);
          document.body.classList.remove("dragging-active");
        }
      }
    };
    const onDragOver = (e: DragEvent | any) => {
      e.preventDefault();
    };
    const onDrop = (e: DragEvent | any) => {
      dragCounter = 0;
      setIsExternalDragActive(false);
      document.body.classList.remove("dragging-active");
      e.preventDefault();
    };
    window.addEventListener("dragenter", onDragEnter as any);
    window.addEventListener("dragleave", onDragLeave as any);
    window.addEventListener("dragover", onDragOver as any);
    window.addEventListener("drop", onDrop as any);
    return () => {
      window.removeEventListener("dragenter", onDragEnter as any);
      window.removeEventListener("dragleave", onDragLeave as any);
      window.removeEventListener("dragover", onDragOver as any);
      window.removeEventListener("drop", onDrop as any);
    };
  }, []);

  // preview video play button show/hide
  const handleVideoMouseEnter = () => {
    const video = videoRef.current;
    if (video && video.paused && !video.src) return;
    if (video && video.paused) {
      setIsPlayButtonVisible(true);
    }
  };
  const handleVideoMouseLeave = () => {
    setIsPlayButtonVisible(false);
  };
  const handleVideoPlay = () => setIsPlayButtonVisible(false);
  const handleVideoPause = () => {
    setIsPlayButtonVisible(true);
  };
  const handlePlayButtonClick = (e: MouseEvent) => {
    e.preventDefault();
    const video = videoRef.current;
    if (video) {
      video.play();
    }
  };

  const removePreviewVideo = () => {
    const video = videoRef.current;
    if (!video) return;
    video.pause();
    video.removeAttribute("src");
    video.load();
  };

  const updateScenePrompt = (sceneIndex: number, prompt: string) => {
    setScenes((prev) =>
      prev.map((scene) =>
        scene.index === sceneIndex ? { ...scene, prompt } : scene
      )
    );
  };

  const ensureSceneSlotsCapacity = (
    sceneIndex: number,
    count: number
  ): Scene[] => {
    return scenes.map((scene) => {
      if (scene.index !== sceneIndex) return scene;

      const cur = scene.slots.length;
      const target = Math.min(count, 3); // cap at 3

      if (cur >= target) return scene;

      const extra = Array.from({ length: target - cur }, (_, i) =>
        createEmptySlot(sceneIndex, cur + i + 1)
      );

      return { ...scene, slots: [...scene.slots, ...extra] };
    });
  };


  // reveal next slot if last is filled and <3
  const revealNextSlot = (sceneIndex: number) => {
    setScenes((prev) => {
      const updated = prev.map((scene) => {
        if (scene.index !== sceneIndex) return scene;
        const slots = scene.slots;
        // allow max 3 assets per scene
        if (slots.length >= 3) return scene;

        const last = slots[slots.length - 1];
        if (!last || !last.imageSrc) return scene;

        return {
          ...scene,
          slots: [
            ...slots,
            createEmptySlot(sceneIndex, slots.length + 1)
          ],
        };
      });
      return updated;
    });
  };

  const updateSlot = (
    sceneIndex: number,
    slotId: string,
    updater: (slot: AssetSlot) => AssetSlot
  ) => {
    setScenes((prev) =>
      prev.map((scene) => {
        if (scene.index !== sceneIndex) return scene;
        return {
          ...scene,
          slots: scene.slots.map((slot) =>
            slot.id === slotId ? updater(slot) : slot
          ),
        };
      })
    );
  };

  const handleSlotClick = (
    e: MouseEvent,
    sceneIndex: number,
    slotId: string
  ) => {
    e.preventDefault();
    e.stopPropagation();

    const scene = scenes.find((s) => s.index === sceneIndex);
    if (!scene) return;

    const slot = scene.slots.find((s) => s.id === slotId);
    if (!slot) return;

    // EMPTY SLOT → PICK MULTIPLE FILES
    if (!slot.imageSrc) {
      setFileTarget({ sceneIndex, slotId });
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
        fileInputRef.current.click();
      }
      return;
    }

    // FILLED SLOT → open context menu
    setContextTarget({ sceneIndex, slotId });
    setOriginalFilter(slot.filter || "none");
    setTempFilter(null);
    setCtxMenuVisible(true);
    setCtxMenuPos({ x: e.pageX, y: e.pageY });
  };


  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!fileTarget) return;

    const files = Array.from(e.target.files || []).filter(f =>
      f.type.startsWith("image/")
    );

    if (files.length === 0) return;

    let queue = [...files];
    let sceneIdx = fileTarget.sceneIndex;

    setScenes(prevScenes => {
      let newScenes = [...prevScenes];

      const placeImages = () => {
        while (queue.length > 0) {
          let scene = newScenes.find(s => s.index === sceneIdx);

          // if scene does not exist → create new scene
          if (!scene) {
            scene = {
              index: sceneIdx,
              prompt: "",
              slots: [createEmptySlot(sceneIdx, 1)]
            };
            newScenes.push(scene);
          }

          // find first empty slot
          let emptySlot = scene.slots.find(s => !s.imageSrc);

          // if full → add slot IF less than 3
          if (!emptySlot) {
            // If scene has fewer than 3 slots, create a new one
            if (scene.slots.length < 3) {
              const newSlot = createEmptySlot(sceneIdx, scene.slots.length + 1);
              scene.slots.push(newSlot);
              emptySlot = newSlot;
            } else {
              // Scene IS full at 3 images → move to next scene
              // BUT also ensure the next scene exists with at least ONE empty slot
              sceneIdx++;
          
              let nextScene = newScenes.find(s => s.index === sceneIdx);
              if (!nextScene) {
                nextScene = {
                  index: sceneIdx,
                  prompt: "",
                  slots: [createEmptySlot(sceneIdx, 1)]
                };
                newScenes.push(nextScene);
              }
          
              continue; // retry fill on next iteration
            }
          }
          

          // fill the slot
          const file = queue.shift();
          if (!file) break;

          emptySlot.imageSrc = URL.createObjectURL(file);
          emptySlot.filter = "none";
        }
      };

      placeImages();
      return newScenes;
    });
  };


  const requestDelete = (sceneIndex: number, slotId: string, e?: Event) => {
    if (e && "stopPropagation" in e) {
      e.stopPropagation();
    }
    setSlotToDelete({ sceneIndex, slotId });
    setShowDeleteModal(true);
  };

  const hideDeleteModal = () => {
    setShowDeleteModal(false);
    setSlotToDelete(null);
  };

  const confirmDelete = () => {
    if (!slotToDelete) return;
    const { sceneIndex, slotId } = slotToDelete;
    updateSlot(sceneIndex, slotId, () => ({
      id: slotId,
      imageSrc: null,
      filter: "none",
    }));
    hideDeleteModal();
  };

  // context menu effects
  const applyEffect = (type: string) => {
    if (!contextTarget) return;
    const { sceneIndex, slotId } = contextTarget;
    if (type === "enhance") {
      commitFilter("contrast(1.2) brightness(1.1)");
    } else if (type === "colorize") {
      commitFilter("saturate(1.5) sepia(0.2)");
    } else if (type === "delete") {
      requestDelete(sceneIndex, slotId);
      setCtxMenuVisible(false);
    }
  };

  const previewFilter = (val: string) => {
    if (!contextTarget) return;
    setTempFilter(val);
    const { sceneIndex, slotId } = contextTarget;
    setScenes((prev) =>
      prev.map((scene) => {
        if (scene.index !== sceneIndex) return scene;
        return {
          ...scene,
          slots: scene.slots.map((slot) =>
            slot.id === slotId ? { ...slot, filter: val } : slot
          ),
        };
      })
    );
  };

  const commitFilter = (val: string) => {
    if (!contextTarget) return;
    const { sceneIndex, slotId } = contextTarget;
    updateSlot(sceneIndex, slotId, (slot) => ({
      ...slot,
      filter: val,
    }));
    setOriginalFilter(val);
    setTempFilter(null);
    setCtxMenuVisible(false);
    setContextTarget(null);
  };

  // drag & drop internal + external
  const handleDragStart = (
    e: React.DragEvent<HTMLImageElement>,
    sceneIndex: number,
    slotId: string
  ) => {
    setDragSource({ sceneIndex, slotId });
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragEnd = (e: React.DragEvent<HTMLImageElement>) => {
    setDragSource(null);
  };

  const allowDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const handleSlotDragEnter = (
    e: DragEvent<HTMLDivElement>,
    sceneIndex: number,
    slotId: string
  ) => {
    e.preventDefault();
    setSceneDropHighlight(sceneIndex);
    setSlotDropHighlight(slotId);
  };

  const handleSlotDragLeave = (
    e: DragEvent<HTMLDivElement>,
    sceneIndex: number,
    slotId: string
  ) => {
    setSlotDropHighlight((prev) => (prev === slotId ? null : prev));
    setSceneDropHighlight((prev) => (prev === sceneIndex ? null : prev));
  };

  const handleDrop = (
    e: DragEvent<HTMLDivElement>,
    sceneIndex: number,
    slotId: string
  ) => {
    console.log('dropped on scene', sceneIndex, 'slot', slotId);
    e.preventDefault();
    e.stopPropagation();
    setSceneDropHighlight(null);
    setSlotDropHighlight(null);
    document.body.classList.remove("dragging-active");
    setIsExternalDragActive(false);

    const targetSceneIndex = sceneIndex;
    const targetId = slotId;

    // Internal move
    // Internal swap/move
    if (dragSource) {
      const srcSceneIndex = dragSource.sceneIndex;
      const srcSlotId = dragSource.slotId;

      // If drag source equals drop target → do nothing
      if (srcSceneIndex === sceneIndex && srcSlotId === slotId) {
        setDragSource(null);
        return;
      }

      setScenes(prev => {
        let newScenes = [...prev];

        let sourceImage: string | null = null;
        let sourceFilter: string = "none";
        let targetImage: string | null = null;
        let targetFilter: string = "none";

        // Read source + target before modifying
        newScenes.forEach(scene => {
          if (scene.index === srcSceneIndex) {
            const s = scene.slots.find(sl => sl.id === srcSlotId);
            if (s) {
              sourceImage = s.imageSrc;
              sourceFilter = s.filter;
            }
          }
          if (scene.index === sceneIndex) {
            const t = scene.slots.find(sl => sl.id === slotId);
            if (t) {
              targetImage = t.imageSrc;
              targetFilter = t.filter;
            }
          }
        });

        // Now write swapped values
        newScenes = newScenes.map(scene => {
          if (scene.index === srcSceneIndex || scene.index === sceneIndex) {
            return {
              ...scene,
              slots: scene.slots.map(slot => {
                if (scene.index === srcSceneIndex && slot.id === srcSlotId) {
                  return {
                    ...slot,
                    imageSrc: targetImage,
                    filter: targetFilter,
                  };
                }
                if (scene.index === sceneIndex && slot.id === slotId) {
                  return {
                    ...slot,
                    imageSrc: sourceImage,
                    filter: sourceFilter,
                  };
                }
                return slot;
              }),
            };
          }
          return scene;
        });

        // After internal swap, add new empty slot if scene has less than 3 slots
        newScenes = newScenes.map(scene => {
          if (scene.index === sceneIndex) {
            if (scene.slots.length < 3) {
              // Ensure slot ids are unique as per createEmptySlot logic
              const nextSlotNumber = scene.slots.length + 1;
              return {
                ...scene,
                slots: [
                  ...scene.slots,
                  createEmptySlot(scene.index, nextSlotNumber),
                ],
              };
            }
          }
          return scene;
        });

        return newScenes;
      });

      setDragSource(null);
      return;
    }

    // External file drop
    const dt = e.dataTransfer;
    if (dt?.files?.[0]) {
      const file = dt.files[0];
      if (!file.type.startsWith("image/")) return;
      const reader = new FileReader();
      reader.onload = (evt) => {
        const src = String(evt.target?.result || "");

        updateSlot(targetSceneIndex, targetId, (slot) => ({
          ...slot,
          imageSrc: src,
          filter: "none",
        }));

        // Create new empty slot if the slots in the scene are less than 3
        const scene = scenes.find(s => s.index === targetSceneIndex);
        if (!scene) return;
        if (scene.slots.length < 3) {
          revealNextSlot(targetSceneIndex);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const setRatio = (ratio: "9/16" | "16/9") => {
    setVideoAspect(ratio);
    setPreviewWidth(ratio === "16/9" ? "500px" : "350px");
  };

  // package selector / scenes count
  const handleSetScenes = (count: number, priceValue: number) => {
    setCurrentSceneCount(count);
    setPrice(priceValue);

    setScenes((prev) => {
      let newScenes = [...prev];

      if (newScenes.length === 0) {
        // should not happen with our init
        newScenes = Array.from({ length: count }, (_, i) => {
          const index = i + 1;
          return {
            index,
            prompt: index === 1 ? defaultPromptScene1 : "",
            slots:
              index === 1
                ? [
                  { id: "scene-1-slot-1", imageSrc: "image1.jpg", filter: "none" },
                  { id: "scene-1-slot-2", imageSrc: "image2.jpg", filter: "none" },
                  { id: "scene-1-slot-3", imageSrc: "image3.jpg", filter: "none" },
                ]
                : [createEmptySlot(index, 1)],
          };
        });
        return newScenes;
      }

      if (count > newScenes.length) {
        // add scenes
        const lastIdx = newScenes.length;
        const extra = Array.from({ length: count - lastIdx }, (_, i) => {
          const index = lastIdx + i + 1;
          return {
            index,
            prompt: "",
            slots: [createEmptySlot(index, 1)],
          };
        });
        newScenes = [...newScenes, ...extra];
      } else if (count < newScenes.length) {
        // trim scenes from end
        newScenes = newScenes
          .filter((scene) => scene.index <= count)
          .map((scene) => scene);
      }

      return newScenes;
    });
  };

  const isPkgActive = (count: number) => currentSceneCount === count;

  return (
    <div ref={rootRef}>
      <style>{styles}</style>

      {/* Checkout Modal */}
      {showCheckoutModal && <div
  className={`modal-backdrop ${showCheckoutModal ? "show" : ""}`}
  id="checkout-modal"
  style={{
    zIndex: 50,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem",
  }}
>
  <div
    className="modal-card"
    style={{
      width: "100%",
      maxWidth: 480,
      background: "linear-gradient(135deg, #f8fafc 60%, #e3eeff 100%)",
      boxShadow: "0 8px 28px rgba(0,0,0,0.13)",
      borderRadius: 16,
      padding: "1.6rem 1.2rem",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "1.25rem",
    }}
  >
    <div
      className="modal-title"
      style={{
        fontWeight: 800,
        fontSize: "1.4rem",
        letterSpacing: "0.02em",
        textAlign: "center",
        width: "100%",
      }}
    >
      Complete Your Video Order
    </div>

    <div style={{ textAlign: "center", width: "100%" }}>
      <p
        style={{
          color: "var(--text-light)",
          fontSize: "1.05rem",
          margin: 0,
          marginBottom: "0.1rem",
        }}
      >
        Total:{" "}
        <strong style={{ color: "var(--brand)", fontSize: "1.2rem" }}>
          ${price.toFixed(2)}
        </strong>
      </p>
      <div
        style={{
          color: "#504e7a",
          fontSize: "0.99rem",
          marginTop: 2,
          display: "flex",
          justifyContent: "center",
          gap: 16,
        }}
      >
        <span>
          {scenes.length} scene{scenes.length !== 1 && "s"}
        </span>
        <span>&middot;</span>
        <span>
          {
            // Sum up filled slots (assets)
            scenes.reduce(
              (total, s) => total + s.slots.filter(slot => !!slot.imageSrc).length,
              0
            )
          } asset
          {
            scenes.reduce(
              (total, s) => total + s.slots.filter(slot => !!slot.imageSrc).length,
              0
            ) !== 1 && "s"
          }
        </span>
      </div>
    </div>

    <div
      style={{
        fontSize: "0.95rem",
        color: "var(--text-light)",
        background: "rgba(99, 91, 255, 0.06)",
        borderRadius: "0.5em",
        padding: "0.7em",
        textAlign: "center",
        fontWeight: 500,
        width: "100%",
      }}
    >
      🚚 Your video will be delivered to your email {userEmail} in{" "}
      <strong>24 hours or less</strong>.
    </div>

    <form
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "1.2rem",
        maxWidth: 420,
      }}
      onSubmit={(e) => e.preventDefault()}
    >
      {/* EMAIL */}
      <div style={{ width: "100%" }}>
        <label
          htmlFor="userEmail"
          style={{
            fontWeight: 600,
            fontSize: "1rem",
            color: "#635bff",
            marginBottom: 6,
            display: "block",
          }}
        >
          Email
        </label>
        <input
          id="userEmail"
          type="email"
          placeholder="Enter your email"
          value={userEmail}
          autoComplete="email"
          onChange={(e) => setUserEmail(e.target.value)}
          style={{
            width: "100%",
            padding: "0.7rem 1rem",
            fontSize: "1rem",
            border: "2px solid #dadbeb",
            borderRadius: 8,
            outline: "none",
            background: "#f7f8fe",
            transition: "0.2s",
          }}
          onFocus={(e) =>
            (e.currentTarget.style.border = "2px solid #635bff")
          }
          onBlur={(e) =>
            (e.currentTarget.style.border =
              emailConfirmed &&
              userEmail === confirmedEmail &&
              userEmail.length > 0
                ? "2px solid #44b672"
                : "2px solid #dadbeb")
          }
        />
      </div>

      {/* CONFIRM EMAIL */}
      <div style={{ width: "100%" }}>
        <label
          htmlFor="confirmEmail"
          style={{
            fontWeight: 600,
            fontSize: "1rem",
            color: "#635bff",
            marginBottom: 6,
            display: "block",
          }}
        >
          Confirm Email
        </label>
        <div style={{ position: "relative" }}>
          <input
            id="confirmEmail"
            type="email"
            placeholder="Type again to confirm"
            value={confirmedEmail ?? ""}
            autoComplete="email"
            onChange={(e) => setConfirmedEmail(e.target.value)}
            style={{
              width: "100%",
              padding: "0.7rem 1rem",
              fontSize: "1rem",
              border:
                emailConfirmed &&
                userEmail === confirmedEmail &&
                userEmail.length > 0
                  ? "2px solid #44b672"
                  : confirmedEmail &&
                    confirmedEmail.length > 0 &&
                    userEmail !== confirmedEmail
                  ? "2px solid #ff726a"
                  : "2px solid #dadbeb",
              borderRadius: 8,
              outline: "none",
              background: "#f7f8fe",
              transition: "0.2s",
            }}
            onFocus={(e) =>
              (e.currentTarget.style.border =
                userEmail === confirmedEmail &&
                userEmail.length > 0
                  ? "2px solid #44b672"
                  : "2px solid #635bff")
            }
            onBlur={(e) =>
              (e.currentTarget.style.border =
                emailConfirmed &&
                userEmail === confirmedEmail &&
                userEmail.length > 0
                  ? "2px solid #44b672"
                  : "2px solid #dadbeb")
            }
          />

          {/* CHECKMARK / X */}
          {emailConfirmed &&
            userEmail === confirmedEmail &&
            userEmail.length > 0 && (
              <span
                style={{
                  position: "absolute",
                  right: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#44b672",
                }}
              >
                ✔️
              </span>
            )}

          {confirmedEmail &&
            confirmedEmail.length > 0 &&
            userEmail !== confirmedEmail && (
              <span
                style={{
                  position: "absolute",
                  right: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#ff726a",
                }}
              >
                ❌
              </span>
            )}
        </div>
      </div>
    </form>

    {/* PAYMENT */}
    <div style={{ width: "100%", maxWidth: 440, position: "relative" }}>
      <BraintreeDropIn
        amount={price}
        setPaymentProcessing={setPaymentProcessing}
        paymentProcessing={paymentProcessing}
        order={fullOrder}
        onPayment={() => {
          setShowCheckoutModal(false);
          setShowSuccessModal(true);
        }}
      />
      {(
        !userEmail ||
        !confirmedEmail ||
        userEmail !== confirmedEmail ||
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userEmail) ||
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(confirmedEmail)
      ) && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "rgba(255,255,255,0.7)",
            zIndex: 2,
            pointerEvents: "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1.1rem",
            color: "#666",
            borderRadius: 14,
            transition: "background 0.2s",
          }}
        >
          <span>
            Please enter valid, matching emails to proceed.
          </span>
        </div>
      )}
    </div>

    {/* BACK BUTTON */}
    <div style={{ width: "100%" }}>
      <button
        onClick={() => setShowCheckoutModal(false)}
        style={{
          width: "100%",
          padding: "0.85rem",
          fontSize: "1rem",
          borderRadius: 8,
          background: "#eef1ff",
          border: "1px solid #ccd1ff",
          fontWeight: 600,
        }}
      >
        Back
      </button>
    </div>
  </div>

  <style>
    {`
      @media (max-width: 700px) {
        #checkout-modal {
          align-items: flex-start !important;
          padding-top: 1.5rem !important;
        }

        #checkout-modal .modal-card {
          padding: 1.1rem !important;
          max-width: 100% !important;
          border-radius: 10px !important;
          gap: 1rem !important;
        }

        #checkout-modal input {
          font-size: 1rem !important;
          padding: 0.65rem 0.85rem !important;
        }

        #checkout-modal .modal-title {
          font-size: 1.15rem !important;
        }

        #checkout-modal label {
          font-size: 0.92rem !important;
        }
      }
    `}
  </style>
</div>}


      {/* Global Drag Overlay */}
      {/* <div id="drag-overlay">
        <h2>Drop to Upload</h2>
        <p>Your memories will be auto-sorted</p>
      </div> */}

      {/* Success Modal */}
      <div
        className={`modal-backdrop ${showSuccessModal ? "show" : ""}`}
        id="success-modal"
        tabIndex={-1}
        onClick={(e) => {
          // Only close if backdrop itself is clicked (not modal)
          if (e.target === e.currentTarget) setShowSuccessModal(false);
        }}
        onKeyDown={(e) => {
          if (e.key === "Escape") setShowSuccessModal(false);
        }}
      >
        <div
          className="modal-card"
          tabIndex={0}
          onBlur={(e) => {
            // If losing focus to outside the modal, hide the modal
            if (
              e.relatedTarget === null ||
              !(e.currentTarget as Node).contains(e.relatedTarget as Node)
            ) {
              setShowSuccessModal(false);
            }
          }}
        >
          <div className="modal-title">Payment Successful!</div>
          <p style={{ color: "var(--text-light)", fontSize: "0.9rem" }}>
            Your video has been created and will be delivered to your email {userEmail} in 24 hours or less.
          </p>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <div
        className={`modal-backdrop ${showDeleteModal ? "show" : ""}`}
        id="delete-modal"
      >
        <div className="modal-card">
          <div className="modal-title">Remove Memory?</div>
          <p
            style={{
              color: "var(--text-light)",
              fontSize: "0.9rem",
            }}
          >
            This asset will be removed from the scene. This action cannot be
            undone.
          </p>
          <div className="modal-actions">
            <button
              className="btn-modal btn-cancel"
              onClick={hideDeleteModal}
            >
              Cancel
            </button>
            <button className="btn-modal btn-confirm" onClick={confirmDelete}>
              Remove
            </button>
          </div>
        </div>
      </div>

      {/* Context Menu */}
      <div
        id="context-menu"
        style={{
          display: ctxMenuVisible ? "flex" : "none",
          left: ctxMenuPos.x,
          top: ctxMenuPos.y,
        }}
      >
        <div className="ctx-item" onClick={() => applyEffect("enhance")}>
          <span>✨ Enhance</span>
        </div>
        <div className="ctx-item" onClick={() => applyEffect("colorize")}>
          <span>🎨 Colorize</span>
        </div>
        <div className="ctx-item" onClick={() => applyEffect("delete")}>
          <span>🗑️ Delete</span>
        </div>
        <div className="ctx-divider" />
        <div className="ctx-item">
          <span>Filters</span> <span>›</span>
          <div className="ctx-submenu">
            <div
              className="ctx-item"
              onMouseEnter={() => previewFilter("sepia(1)")}
              onClick={() => commitFilter("sepia(1)")}
            >
              Vintage Sepia
            </div>
            <div
              className="ctx-item"
              onMouseEnter={() => previewFilter("grayscale(1)")}
              onClick={() => commitFilter("grayscale(1)")}
            >
              B&amp;W Noir
            </div>
            <div
              className="ctx-item"
              onMouseEnter={() => previewFilter("saturate(2)")}
              onClick={() => commitFilter("saturate(2)")}
            >
              Vivid Pop
            </div>
            <div
              className="ctx-item"
              onMouseEnter={() => previewFilter("none")}
              onClick={() => commitFilter("none")}
            >
              Reset
            </div>
          </div>
        </div>
      </div>

      {/* Navbar */}
      {!showCheckoutModal && <nav className="navbar">
        <div className="brand">
          Life <span>Replayed</span>
        </div>
        {/* <div
          style={{
            fontSize: "0.9rem",
            color: "var(--text-light)",
            cursor: "pointer",
          }}
          onClick={showGoogleSignInModal}
        >
          Sign In
        </div> */}
      </nav>}

      {/* Google Sign In Modal */}
      <div
        className={`modal-backdrop ${showGoogleModal ? "show" : ""
          }`}
        id="google-signin-modal"
      >
        <div
          className="modal-card"
          style={{
            animation:
              "popInScale 0.25s cubic-bezier(.22,1.11,.56,1.14) backwards",
          }}
        >
          <div
            className="modal-title"
            style={{
              animation:
                "fadeInUp 0.38s cubic-bezier(.23, 1.07, .48, 1.02) forwards",
            }}
          >
            Sign in with Google
          </div>
          <p
            style={{
              color: "var(--text-light)",
              fontSize: "0.9rem",
              animation: "fadeInUp 0.5s 0.08s backwards",
            }}
          >
            Sign in to sync your tributes and access them anytime.
          </p>
          <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
            <button
              id="google-signin-btn"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                background: "#fff",
                border: "1px solid #CCC",
                borderRadius: 8,
                padding: "10px 24px",
                fontSize: "1rem",
                cursor: "pointer",
                boxShadow: "0 2px 12px rgba(99,99,99,0.07)",
                transition: "box-shadow 0.17s, transform 0.11s",
              }}
              onClick={googleSignIn}
            >
              <img
                src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                style={{ width: 24, height: 24, transition: "transform 0.14s" }}
                alt="Google Icon"
              />
              <span style={{ transition: "color 0.15s" }}>
                Sign in with Google
              </span>
            </button>
          </div>
          <div
            className="modal-actions"
            style={{ animation: "fadeInUp 0.6s 0.14s backwards" }}
          >
            <button
              className="btn-modal btn-cancel"
              style={{
                transition:
                  "background 0.17s, color 0.15s, transform 0.09s",
              }}
              onMouseOver={(e) => {
                (e.currentTarget as HTMLButtonElement).style.background =
                  "var(--secondary)";
                (e.currentTarget as HTMLButtonElement).style.color = "#fff";
              }}
              onMouseOut={(e) => {
                (e.currentTarget as HTMLButtonElement).style.background = "";
                (e.currentTarget as HTMLButtonElement).style.color = "";
              }}
              onMouseDown={(e) => {
                (e.currentTarget as HTMLButtonElement).style.transform =
                  "scale(0.95)";
              }}
              onMouseUp={(e) => {
                (e.currentTarget as HTMLButtonElement).style.transform =
                  "scale(1)";
              }}
              onClick={hideGoogleSignInModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

      {/* Main Layout */}
      <div className="studio-grid">
        {/* Left: Editor / Timeline */}
        <div className="left-scroll-wrapper">
        <div className="editor-panel">
          <div style={{ marginBottom: 20 }}>
            <h1
              style={{
                fontSize: "2.2rem",
                fontWeight: 800,
                color: "#333",
                letterSpacing: 0.5,
              }}
            >
              Bring Your Photos to Life With AI
            </h1>
            <p style={{ color: "var(--text-light)", marginTop: 5 }}>
              Drag photos to scenes. Re-arrange by dragging between slots.
              Click an image for filters &amp; options.
            </p>
          </div>

          {/* Package Selector */}
          <div className="package-selector">
            <div
              className={`pkg-card ${isPkgActive(3) ? "active" : ""
                }`}
              onClick={() => handleSetScenes(3, 24.9)}
            >
              <div className="pkg-price">$24.90</div>
              <div>Micro (24s)</div>
            </div>
            <div
              className={`pkg-card ${isPkgActive(8) ? "active" : ""
                }`}
              onClick={() => handleSetScenes(8, 59.9)}
            >
              <div className="pkg-price">$59.90</div>
              <div>Standard (64s)</div>
            </div>
            <div
              className={`pkg-card ${isPkgActive(12) ? "active" : ""
                }`}
              onClick={() => handleSetScenes(12, 89.9)}
            >
              <div className="pkg-price">$89.90</div>
              <div>Extended (96s)</div>
            </div>
          </div>

          {/* Timeline Container */}
          <div className="timeline-container">
            {scenes
              .filter((s) => s.index <= currentSceneCount)
              .map((scene) => {
                const start = (scene.index - 1) * 8;
                const end = scene.index * 8;

                // Add: handler for clearing all assets from this scene
                const removeAllAssetsFromScene = (sceneIdx: number) => {
                  const confirmRemove = window.confirm(
                    "Are you sure you want to remove all photos from this scene? This cannot be undone."
                  );
                  if (!confirmRemove) return;
                  setScenes((prevScenes) =>
                    prevScenes.map((s) =>
                      s.index === sceneIdx
                        ? {
                          ...s,
                          slots: s.slots.map((slot) => ({
                            ...slot,
                            imageSrc: undefined,
                            // Optionally reset other slot fields if needed, like filter
                            filter: "none",
                          })),
                        }
                        : s
                    )
                  );
                };

                return (
                  <div
                    key={scene.index}
                    className={`scene-card ${sceneDropHighlight === scene.index
                        ? "drop-target-scene"
                        : ""
                      }`}
                    data-scene-index={scene.index}
                  >
                    <div className="scene-header">
                      <span>SCENE {scene.index}</span>
                      <span>
                        0:{String(start).padStart(2, "0")} - 0:
                        {String(end).padStart(2, "0")}
                      </span>
                      {/* Add: 'Remove All Photos' button for this scene */}
                      {scene.slots.some(slot => slot.imageSrc) && (
                        <button
                          className="scene-clear-assets-btn"
                          style={{
                            marginLeft: 10,
                            height: 32,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "0.85em",
                            background: "#f0f0f0",
                            borderRadius: "50px",
                            border: "none",
                            color: "var(--brand)",
                            cursor: "pointer",
                            padding: "0 12px",
                            fontWeight: 600,
                            gap: 6,
                          }}
                          title="Remove all photos from this scene"
                          onClick={() => removeAllAssetsFromScene(scene.index)}
                          type="button"
                        >
                          🗑️ <span style={{ fontSize: "0.76em" }}>Clear Scene</span>
                        </button>
                      )}
                    </div>
                    <div
                      className="scene-assets"
                      id={`scene-${scene.index}-assets`}
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {scene.slots.map((slot, idx) => (
                        <div
                          key={slot.id}
                          className={`asset-slot ${slot.imageSrc ? "filled" : ""
                            } ${slotDropHighlight === slot.id
                              ? "drop-target"
                              : ""
                            }`}
                          data-scene={scene.index}
                          data-filter={slot.filter}
                          onClick={(e) =>
                            handleSlotClick(e, scene.index, slot.id)
                          }
                          onDrop={(e) =>
                            handleDrop(e, scene.index, slot.id)
                          }
                          onDragOver={allowDrop}
                          onDragEnter={(e) =>
                            handleSlotDragEnter(
                              e,
                              scene.index,
                              slot.id
                            )
                          }
                          onDragLeave={(e) =>
                            handleSlotDragLeave(
                              e,
                              scene.index,
                              slot.id
                            )
                          }
                        >
                          {!slot.imageSrc && (
                            <>
                              <div className="add-hint">+</div>
                              <div className="slot-label">
                                Drop Photo (3 max)
                              </div>
                            </>
                          )}
                          {slot.imageSrc && (
                            <>
                              <div
                                className="remove-btn"
                                onClick={(evt) => {
                                  evt.stopPropagation();
                                  requestDelete(
                                    scene.index,
                                    slot.id
                                  );
                                }}
                              >
                                ✕
                              </div>
                              <img
                                src={slot.imageSrc}
                                style={{ filter: slot.filter }}
                                draggable={true}
                                onDragStart={(e) =>
                                  handleDragStart(
                                    e,
                                    scene.index,
                                    slot.id
                                  )
                                }
                                onDragEnd={handleDragEnd}
                              />
                              <div className="filter-badge">
                                Filter
                              </div>
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                    <textarea
                      id={`scene-${scene.index}-prompt`}
                      placeholder="Give a brief description of the scene"
                      className="scene-prompt"
                      value={scene.prompt}
                      onChange={(e) =>
                        updateScenePrompt(
                          scene.index,
                          e.target.value
                        )
                      }
                    />
                  </div>
                );
              })}
          </div>
        </div>
        </div>

        {/* Right: Preview Panel */}
        <div className="preview-panel">
          <div
            className="video-container"
            onMouseEnter={handleVideoMouseEnter}
            onMouseLeave={handleVideoMouseLeave}
          >
            <div className="ratio-toggles">
              <button
                className={`ratio-btn ${videoAspect === "9/16" ? "active" : ""
                  }`}
                onClick={() => setRatio("9/16")}
              >
                9:16
              </button>
              <button
                className={`ratio-btn ${videoAspect === "16/9" ? "active" : ""
                  }`}
                onClick={() => setRatio("16/9")}
              >
                16:9
              </button>
            </div>
            <div
              className="video-preview-wrapper"
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
              }}
            >
              <video
                id="live-preview-video"
                ref={videoRef}
                src="sample.mp4"
                controls
                loop
                autoPlay
                muted
                playsInline
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "var(--radius-lg)",
                  display: "block",
                }}
                onPlay={handleVideoPlay}
                onPause={handleVideoPause}
              />
              <button
                id="live-preview-play-btn"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  background: "rgba(0,0,0,0.6)",
                  border: "none",
                  color: "white",
                  borderRadius: "50%",
                  width: 60,
                  height: 60,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "2rem",
                  cursor: "pointer",
                  opacity: isPlayButtonVisible ? 1 : 0,
                  pointerEvents: isPlayButtonVisible
                    ? "auto"
                    : "none",
                  transition: "opacity 0.2s",
                  zIndex: 10,
                }}
                onClick={handlePlayButtonClick}
              >
                ▶
              </button>

              {/* Replace/Remove Buttons */}
              <div
                id="preview-controls"
                style={{
                  position: "absolute",
                  bottom: 15,
                  left: "50%",
                  transform: "translateX(-50%)",
                  display: "flex",
                  gap: 10,
                  zIndex: 20,
                }}
              >
                <button
                  className="remove-preview-btn"
                  onClick={removePreviewVideo}
                  style={{
                    background: "#ff726a",
                    color: "white",
                    border: "none",
                    padding: "6px 12px",
                    borderRadius: "50%",
                    width: 32,
                    height: 32,
                    cursor: "pointer",
                    fontSize: "1.2rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <line
                      x1="4"
                      y1="4"
                      x2="12"
                      y2="12"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                    <line
                      x1="12"
                      y1="4"
                      x2="4"
                      y2="12"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <button onClick={() => setShowCheckoutModal(true)} className="generate-btn">
            Produce <span id="price-tag">${price.toFixed(2)}</span>
          </button>
        </div>
      </div>

      {/* First-Visit Intro Modal */}
      <div
        className={`modal-backdrop ${showIntroModal ? "show" : ""
          }`}
        id="intro-modal"
      >
        <div className="intro-card">
          <div className="intro-title brand">Ready?</div>
          <p className="intro-desc">
            Transform old photos into animated AI stories — colorize, enhance,
            and bring back to life.
          </p>

          <div
            className="before-after-row"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 0,
            }}
          >
            <div
              className="before-col"
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div className="before-label brand">Before</div>
              <div className="before-collage">
                <img src="image3.jpg" />
                <img src="image2.jpg" />
                <img src="image1.jpg" />
              </div>
            </div>

            <div
              style={{
                flex: "0 0 auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                minWidth: 60,
                margin: "0 6px",
              }}
            >
              <span
                style={{
                  fontSize: "3.2rem",
                  color: "black",
                  marginRight: 31,
                  fontFamily: "'Playfair Display', serif",
                  userSelect: "none",
                  fontWeight: 700,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  lineHeight: 1,
                  paddingBottom: 10,
                }}
                aria-hidden="true"
              >
                →
              </span>
            </div>

            <div
              className="after-col"
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div className="after-label brand">After</div>
              <video
                src="sample.mp4"
                muted
                autoPlay
                loop
                playsInline
                style={{
                  width: "100%",
                  borderRadius: "var(--radius-lg)",
                  boxShadow: "var(--shadow-soft)",
                }}
                className="responsive-radius"
              />
            </div>
          </div>

          <button className="intro-btn" onClick={closeIntroModal}>
            Let's Go
          </button>
        </div>
      </div>

      {/* Hidden file input for slot uploads */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        multiple
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

    </div>
  );
};

export default LifeReplayedStudio;
